// 统一管理所有接口
import iotHome from './iotHome'
import iotReport from './iotReport'
export default {
  iotHome,
  iotReport
}